document.addEventListener('DOMContentLoaded', () => {
  const hiddenVariantJsonElement = document.getElementById('hidden-variant-json');
  const initialContent = hiddenVariantJsonElement.dataset.loadContent;
  const variantData = JSON.parse(hiddenVariantJsonElement.textContent);
  const badgeWrapper = document.querySelector('.product-badge-wrapper');

  if (initialContent) {
    const existingBadge = badgeWrapper.querySelector('.corner-badge');
    if (existingBadge) {
      existingBadge.parentNode.removeChild(existingBadge);
    }
    const badgeDiv = document.createElement('div');
    badgeDiv.classList.add('label', 'corner-badge');
    badgeDiv.setAttribute('data-content', initialContent);
    badgeWrapper.append(badgeDiv);
  }

  document.addEventListener('variant:change', (event) => {
    const selectedVariantId = event.detail.variant.id
    if (selectedVariantId) {
      const matchedVariant = variantData.find(item => parseInt(item.variant_id) === selectedVariantId);
      if (matchedVariant) {
        const existingBadge = badgeWrapper.querySelector('.corner-badge');
        if (existingBadge) {
          existingBadge.parentNode.removeChild(existingBadge);
        }
        const badgeDiv = document.createElement('div');
        badgeDiv.classList.add('label', 'corner-badge');
        badgeDiv.setAttribute('data-content', matchedVariant.metafield_value);
        badgeWrapper.append(badgeDiv);
      } else {
        const existingBadge = badgeWrapper.querySelector('.corner-badge');
        if (existingBadge) {
          existingBadge.parentNode.removeChild(existingBadge);
        }
      }
    }
  })
});